var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64147 13.8622C7.48314 13.8622 7.3248 13.8039 7.1998 13.6789C6.95814 13.4372 6.95814 13.0372 7.1998 12.7956L11.9165 8.07891C12.1581 7.83724 12.5581 7.83724 12.7998 8.07891C13.0415 8.32058 13.0415 8.72058 12.7998 8.96224L8.08314 13.6789C7.96647 13.8039 7.7998 13.8622 7.64147 13.8622Z",
    fill: "#D95353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3581 13.8622C12.1998 13.8622 12.0415 13.8039 11.9165 13.6789L7.1998 8.96224C6.95814 8.72058 6.95814 8.32058 7.1998 8.07891C7.44147 7.83724 7.84147 7.83724 8.08314 8.07891L12.7998 12.7956C13.0415 13.0372 13.0415 13.4372 12.7998 13.6789C12.6748 13.8039 12.5165 13.8622 12.3581 13.8622Z",
    fill: "#D95353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 19.8372H7.49984C2.97484 19.8372 1.0415 17.9039 1.0415 13.3789V8.37891C1.0415 3.85391 2.97484 1.92058 7.49984 1.92058H12.4998C17.0248 1.92058 18.9582 3.85391 18.9582 8.37891V13.3789C18.9582 17.9039 17.0248 19.8372 12.4998 19.8372ZM7.49984 3.17058C3.65817 3.17058 2.2915 4.53724 2.2915 8.37891V13.3789C2.2915 17.2206 3.65817 18.5872 7.49984 18.5872H12.4998C16.3415 18.5872 17.7082 17.2206 17.7082 13.3789V8.37891C17.7082 4.53724 16.3415 3.17058 12.4998 3.17058H7.49984Z",
    fill: "#D95353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.878906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquare);
export default __webpack_public_path__ + "static/media/close-square.41b23867173b08bae95a8c8315dc9432.svg";
export { ForwardRef as ReactComponent };